var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasDialogLogin)?_c('DialogLogin',{attrs:{"dialog-visible":_vm.hasDialogLogin,"loginConfig":_vm.loginConfig},on:{"loginAfterHandle":_vm.handleAfterLoginAndInformationImproved,"closeDialog":function () {
      _vm.isDialog(false);
    }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }